
import api from '@/api/common'

import { getDocConfig } from '@/api/productArchive'
import common from '@/utils/common'

// 公共 config
const getConfig = (params={}) => {
  return new Promise((resolve, reject) => {
    params['app_id'] = common.getQueryString('weChat')
    api.getConfig(params).then(result => {
      resolve(result)
    })
  })
}
// 产品文档 config
const getDocConfigFun = (params={}) => {
  return new Promise(async (resolve, reject) => {
    params['app_id'] = common.getQueryString('weChat')
    let result = await getDocConfig(params)
    resolve(result)
  })
}


const config = {
  state: {
    config: {},
    productArchive: {}
  },

  mutations: {
    SET_CONFIG: (state, config) => {
      state.config = config
    },
    SET_PRODUCTDOC: (state, data) => {
      state.productArchive = data
    },
  },
  getters: {
    getProductArchive (state) {
      let _keys = Object.keys(state.productArchive)
      if (!_keys.length) {
        getDocConfigFun().then(result => {
          state.productArchive = result
        })
      }
      return state.productArchive
    }
  },
  actions: {
		// 刷新 config
    RefreshConfig({ commit }, config) {
      return new Promise(async (resolve, reject) => {
        try {
          await getConfig().then(data => {
            commit('SET_CONFIG', data)
            resolve()
          })
        } catch (error) { }
      })
    },
		// 刷新 config
    RefreshConfig({ commit }, config) {
      return new Promise(async (resolve, reject) => {
        try {
          await getConfig().then(data => {
            commit('SET_CONFIG', data)
            resolve()
          })
        } catch (error) { }
      })
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/modules/config.js